<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs dark
                color="primary"
                v-model="e1"
                show-arrows
        >
          <v-tab key="1">Intestazione</v-tab>
          <v-tab key="2">Cliente</v-tab>
          <v-tab key="3">Documenti Correlati</v-tab>
          <v-tab key="4">Prodotti e Servizi</v-tab>
          <v-tab key="5">Regime Fiscale</v-tab>
          <v-tab key="6">Pagamento</v-tab>
          <v-tab key="7">DDT e Trasporto</v-tab>
          <v-tab key="8">Allegati</v-tab>
          <v-tab key="9">Invio allo SDI</v-tab>

          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-layout row wrap>
                <v-flex sm6 md3>
                  <v-text-field
                      hint="Data documento"
                      persistent-hint
                      prepend-icon="event"
                      mask="##/##/####"
                      return-masked-value
                      v-model="formattedInvoiceDate"
                  ></v-text-field>
                </v-flex>

                <v-flex sm6 md2>
                  <v-select
                      hint="Divisa"
                      :items="currencies"
                      v-model="selectedCurrency"
                      persistent-hint
                  ></v-select>
                </v-flex>

                <v-flex sm5 md3>
                  <v-select
                      hint="Tipo Documento"
                      :items="documentTypes"
                      v-model="selectedDocumentType"
                      persistent-hint
                      return-object
                  ></v-select>
                </v-flex>

                <v-flex sm2 md2>
                  <v-text-field
                      reverse
                      hint="Numero Documento"
                      persistent-hint=""
                      v-model="invoiceNumber"></v-text-field>
                </v-flex>

                <v-flex sm4 md1>
                  <v-combobox
                      hint="Sezionale"
                      :items="sections"
                      v-model="invoice.Section"
                      persistent-hint
                  ></v-combobox>
                </v-flex>
                <v-flex xs1>
                  <fatel-help-tip>
                    <span slot="title">Sezionale</span>
                    <p>E' opzionalmente possibile suddividere le fatture di vendita in diversi
                      sezionali.
                    <p/>
                    <p>Per le fatture rettificative, utilizzare il sezionale R</p>
                    <p>Per le fatture alla Pubblica Amministrazione, è consigliabile utilizzare il sezionale PA</p>
                  </fatel-help-tip>
                </v-flex>

                <v-flex xs12>
                  <v-textarea
                      rows="2"
                      auto-grow
                      clearable
                      counter
                      label="Descrizione"
                      hint="Riga descrittiva o riferimenti normativi da indicare in fattura"
                      persistent-hint
                      v-model="causale"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-form>
            <br/>
            <v-form>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>

                <v-flex xs12>
                  <h3>Bollo Virtuale</h3>
                </v-flex>

                <v-flex xs5>
                  <v-select
                      hint="Applicare Bollo Virtuale?"
                      persistent-hint
                      v-model="virtualStampType"
                      :items="['','SI']"
                  ></v-select>
                </v-flex>
                <v-flex xs1>
                  <fatel-help-tip>
                    <span slot="title">Bollo Virtuale</span>
                    <p>Il bollo di 2 euro è obbligatorio per fatture di importo
                      superiore a 77,47 sulle seguenti operazioni:</p>
                    <p>-operazioni escluse dall’applicazione dell’iva, articolo 15 del
                      Dpr 633/72<br/>
                      -operazioni esenti, articolo 10 del Dpr 633/72<br/>
                      -operazioni fuori campo iva ( mancanza del requisito
                      soggettivo/oggettivo/territoriale)<br/>
                      -regimi forfettari/minimi<br/>
                      -operazioni di esportatori abituali e operazioni assimilate a
                      esportazioni ( articolo 8 c) e 8 bis Dpr 633/72)<br/>
                    <p>Sulla fattura elettronica andrà indicata nella descrizione la
                      dicitura “Imposta di bollo assolta virtualmente ai sensi del DM
                      17.6.2014
                    <p/>
                    <p>Il versamento dell’imposta di bollo avverrà con F24 con scadenza <b>TRIMESTRALE</b>,
                      entro il 20 del mese successivo al trimestre (esempio primo trimestre
                      gennaio/febbraio/marzo entro il 20 aprile).
                    <p/>
                  </fatel-help-tip>
                </v-flex>
                <v-flex xs5>
                  <!--class="form-control"-->
                  <v-text-field
                      hint="Importo Bollo Virtuale (se applicato)"
                      persistent-hint
                      v-model="virtualStampAmount"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-tab-item>

          <v-tab-item key="2">
            <v-layout row wrap>
              <v-flex xs8>
                <v-autocomplete
                    v-model="selectedSubject"
                    :items="subjects"
                    :loading="isSubjectLoading"
                    :search-input.sync="subjectSearch"
                    hide-no-data
                    hide-selected
                    item-text="VisibleName"
                    item-value="Id"
                    label="Cliente"
                    placeholder="Digita per visualizzare l'elenco"
                    prepend-icon="fas fa-users"
                    return-object
                >
                </v-autocomplete>

              </v-flex>
              <v-flex xs1>
                <v-btn color="primary" @click="newSubject()">Crea...</v-btn>
              </v-flex>
              <v-flex xs1>
                <v-btn color="secondary" @click="editSubject()">Modifica</v-btn>
              </v-flex>

              <v-flex xs12>
                <v-divider></v-divider>
              </v-flex>

              <v-flex xs12>
                <h3>Dati Fatturazione</h3>
              </v-flex>

              <v-flex xs5>
                <v-text-field label="Codice Fiscale" readonly
                              :value="selectedSubject.FiscalCode"></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-text-field label="Nazione" readonly
                              :value="selectedSubject.Country"></v-text-field>
              </v-flex>
              <v-flex xs5>
                <v-text-field label="Partita IVA" readonly
                              :value="selectedSubject.VatId"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field label="Codice Ricezione"
                              readonly :value="selectedSubject.SDICode"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field label="PEC Ricezione"
                              readonly
                              :value="selectedSubject.CertifiedEmail"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field label="Email Copia di Cortesia" readonly
                              :value="selectedSubject.InvoiceEmail"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-checkbox class="text-lg-right"
                            label="Invia Copia di cortesia automaticamente" readonly
                            :value="selectedSubject.InvoiceEmailSend"></v-checkbox>
              </v-flex>

              <v-flex xs12>
                <h3>Sede Legale / Residenza</h3>
              </v-flex>

              <v-flex xs1>
                <v-text-field label="Nazione" readonly
                              :value="selectedSubject.OfficeCountry"></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-text-field label="Provincia" readonly
                              :value="selectedSubject.OfficeProvince"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field label="Città" readonly
                              :value="selectedSubject.OfficeCity"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field label="Indirizzo" readonly
                              :value="selectedSubject.OfficeAddress"></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field label="N. Civico" readonly
                              :value="selectedSubject.OfficeStreetNumber"></v-text-field>
              </v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab-item key="3">
            <v-container fluid class="pa-0 ma-0">
              <fatel-linked-documents
                  :dati-generali="invoiceFatelBodyDatiGenerali"
                  v-on:update:dati-ordine-acquisto="updateDatiOrdineAcquisto"
                  v-on:update:dati-contratto="updateDatiContratto">
              </fatel-linked-documents>
            </v-container>
          </v-tab-item>

          <v-tab-item key="4">
            <v-layout row wrap>
              <v-flex xs8>
                <v-autocomplete
                    v-model="selectedProduct"
                    :items="products"
                    :loading="isProductLoading"
                    :search-input.sync="productSearch"
                    hide-no-data
                    hide-selected
                    item-text="Description"
                    item-value="Id"
                    :filter="productsFilter"
                    label="Prodotti e Servizi"
                    placeholder="Digita per visualizzare l'elenco"
                    prepend-icon="fas fa-gift"
                    return-object
                    dense
                >
                  <template
                      slot="item"
                      slot-scope="{ item }"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title v-text="item.Description"></v-list-tile-title>
                      <v-list-tile-sub-title v-text="item.TypeCode"></v-list-tile-sub-title>
                      <v-list-tile-sub-title
                          v-text="item.ArticleCode"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs4>
                <v-btn color="secondary" @click="assignProduct()"
                       :enabled="selectedProduct">Aggiungi
                </v-btn>
                <v-btn color="primary" @click="newProduct()">Crea...</v-btn>
              </v-flex>

              <v-flex xs12>
                <v-divider></v-divider>
              </v-flex>

              <v-card style="max-height: 500px;" class="scroll">
                <v-flex xs12>

                  <v-data-table
                      :headers="productsHeaders"
                      :items="invoiceProducts"
                      hide-actions
                      expand
                  >
                    <template slot="items" slot-scope="props">

                      <!--
                      <td>
                          <v-layout align-center fill-height column>
                              <v-icon small @click="pushUp(props, props.item)">keyboard_arrow_up</v-icon>
                              <v-icon small @click="pushDown(props, props.item)">keyboard_arrow_down</v-icon>
                          </v-layout>
                      </td>
                      -->

                      <td class="px-1">
                        <v-layout row>
                          <v-flex xs6>
                            <v-text-field class="caption"
                                          v-if="props.item.CodiceArticolo"
                                          v-model="props.item.CodiceArticolo[0].CodiceTipo"></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field class="caption"
                                          v-if="props.item.CodiceArticolo"
                                          v-model="props.item.CodiceArticolo[0].CodiceValore"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </td>
                      <td class="px-1">
                        <v-textarea class="caption"
                                    auto-grow
                                    rows="1"
                                    append-outer-icon="speaker_notes"
                                    v-model.lazy="props.item.Descrizione">

                          <v-tooltip bottom slot="append-outer">
                            <v-btn small icon slot="activator" @click="showDetails(props.item, props.index)">
                              <v-icon small>more</v-icon>
                            </v-btn>
                            <label>Dettagli e Note</label>
                          </v-tooltip>

                        </v-textarea>
                      </td>
                      <td class="text-xs-right px-1">
                        <v-text-field type="number" class="caption" reverse
                                      v-model.number="props.item.Quantita"></v-text-field>
                      </td>
                      <td class="px-1">
                        <v-text-field class="caption"
                                      v-model="props.item.UnitaMisura"></v-text-field>
                      </td>
                      <td class="text-xs-right px-1">
                        <fatel-invoicerow-vat-selection :vat-types="vatTypes"
                                                        v-model="props.item"
                                                        @vat-help-click="vatHelpVisible=!vatHelpVisible">
                        </fatel-invoicerow-vat-selection>
                      </td>
                      <td class="text-xs-right px-1">
                        <v-text-field class="caption" prefix='€' reverse
                                      v-model.number="props.item.PrezzoUnitario"></v-text-field>
                      </td>
                      <td class="justify-center align-start px-1">
                        <fatel-invoice-row-discount v-model="props.item">
                        </fatel-invoice-row-discount>
                      </td>
                      <td class="text-xs-right px-1">
                        <v-text-field readonly class="caption" prefix='€' reverse
                                      v-model.number="props.item.PrezzoTotale"></v-text-field>
                      </td>
                      <td class="justify-center px-0">
                        <v-layout align-center fill-height>
                          <!--
                          <v-tooltip bottom>
                              <v-btn slot="activator" icon
                                     small
                                     class="mr-2"
                                     @click="props.expanded = !props.expanded"
                              >
                                  <v-icon small>add</v-icon>
                              </v-btn>
                              <span>Dettagli</span>
                          </v-tooltip>
                          -->
                          <v-tooltip bottom>
                            <v-btn slot="activator" icon
                                   small
                                   class="mr-2"
                                   @click="deleteProduct(props.item)"
                            >
                              <v-icon small>delete</v-icon>
                            </v-btn>
                            <span>Elimina</span>
                          </v-tooltip>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-card>

              <v-flex xs11>
                <v-select
                    hint="Esigibilità IVA"
                    persistent-hint
                    v-model="esigibilitaIVA"
                    :items="[{text:'Immediata', value:'I'},{text:'Differita',value:'D'},{text:'Scissione Pagamenti (Split Payment)',value:'S'}]"
                ></v-select>
              </v-flex>
              <v-flex xs1>
                <fatel-help-tip>
                  <span slot="title">Esigibilità IVA</span>
                  <p>Il default è "Immediata"</p>
                  <p>L'impostazione "Differita" può essere utilizzata solo previo controllo da parte dello Studio</p>
                  <p>L'impostazione "Scissione dei Pagamenti (Split Payment) può essere utilizzata solo previo controllo
                    da parte dello Studio"</p>
                </fatel-help-tip>
              </v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab-item key="5">
            <fatel-fiscal
                :dati-ritenuta="datiRitenuta"
                :dati-cassa="datiCassa"
                :righe-fattura="invoiceProducts"
                v-on:update-dati-ritenuta="updateDatiRitenuta"
                v-on:update-dati-cassa="updateDatiCassa"></fatel-fiscal>
          </v-tab-item>

          <v-tab-item key="6">
            <fatel-payment-list :data-fattura="invoice.Date"
                                :totale-fattura="invoiceTotalAmountToPay"
                                :importo-ritenuta="importoRitenuta"
                                :dati-pagamento="datiPagamento"
                                :sconto-maggiorazione="scontoMaggiorazione"
                                v-on:update:dati-pagamento="setDatiPagamento"
                                v-on:update:sconto-maggiorazione="updateScontoMaggiorazione"></fatel-payment-list>
          </v-tab-item>

          <v-tab-item key="7">
            <fatel-transport-documents
                :fatel-body="invoiceFatelBody"></fatel-transport-documents>
          </v-tab-item>

          <v-tab-item key="8">
            <v-layout row wrap>
              <v-flex xs12>
                <file-pond
                    style="cursor: pointer;"
                    name="pond"
                    ref="pond"
                    label-idle="Carica..."
                    v-bind:allow-multiple="true"
                    accepted-file-types="application/pdf"
                    allow-revert="false"
                />
              </v-flex>
              <v-flex xs12>
                <v-container grid-list-md>
                  <v-layout align-baseline justify-end row fill-height
                            v-bind:key="item.NomeAttachment"
                            v-for="(item,index) in attachments"
                  >

                    <v-flex xs10 grow>
                      <v-text-field
                          v-model="item.DescrizioneAttachment"
                          label="Descrizione Allegato"
                          outline
                          required
                          append-icon="edit"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs1 shrink>
                      <v-icon class="ma-2"
                              @click="downloadAttachment(index, item.NomeAttachment)"
                      >fas fa-file-pdf
                      </v-icon>
                    </v-flex>
                    <v-flex xs1 shrink>
                      <v-icon class="ma-2"
                              @click="removeAttachment(item)"
                      >delete
                      </v-icon>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab-item key="9">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <h3>ATTENZIONE: l'invio &egrave; definitivo!</h3>
                </v-flex>

                <v-flex xs11 md5>
                  <v-text-field v-model="invoice.CourtesyEmail" label="E-Mail"
                                hint="e-mail NON PEC"></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <fatel-help-tip>
                    <span slot="title">E-Mail Copia di Cortesia</span>
                    <p>La <b>Copia di Cortesia</b> &egrave; una copia leggibile della fattura,
                      non valida ai fini fiscali,
                      messa a disposizione del vostro cliente per una pi&ugrave; immediata
                      fruibilit&agrave; del documento.
                    </p>
                    <p>E' vivamente consigliato lasciare sempre abilitato questo campo e
                      inserire un indirizzo email <b>NON</b> PEC a cui verrà recapitato un PDF
                      rappresentante la fattura
                    <p/>
                  </fatel-help-tip>
                </v-flex>

                <v-flex xs12 md6>
                  <v-checkbox class="text-lg-right"
                              label="Invia Copia di cortesia automaticamente"
                              :value="invoice.SendCourtesyCopy"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>

        <br/>

        <v-divider></v-divider>
        <v-btn v-if="e1 > 0" color="accent" @click="goToPreviousPage">&lt;&lt; Indietro</v-btn>
        <v-btn color="primary" @click="save()">Salva Bozza</v-btn>
        <v-btn color="accent" @click="preview()">Anteprima</v-btn>
        <v-btn v-if="e1 < 8" color="accent" @click="goToNextPage()">Avanti &gt;&gt;</v-btn>
        <v-btn color="accent"
               v-if="e1 == 8"
               @click="finalizeDialog=true;finalizationError='';">INVIA allo SDI
        </v-btn>
      </v-flex>

    </v-layout>

    <fatel-invoice-preview doc-type="draft" :invoice-id="this.$store.state.invoiceId" :dialog="previewDialog"
                           v-on:update:dialog="previewDialog=false"></fatel-invoice-preview>

    <v-dialog :key="selectedInvoiceRowIndex"
              v-model="invoiceRowNotesDialog" max-width="600" :persistent="true"
              :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card>
        <v-card-title class="headline">Altri Dati Gestionali</v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field v-model="selectedInvoiceRowTipoDato" label="Tipo Dato"
                            hint="Tipo Dato"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
              auto-grow
              rows="1"
              v-model="selectedInvoiceRowRiferimentoTesto" label="Riferimento Testo"
              hint="Riferimento Testo"></v-textarea>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model.number="selectedInvoiceRowRiferimentoNumero" label="Riferimento Numero"
                            hint="Riferimento Numero"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <fatel-date-field label="Riferimento Data" hint="Riferimento Data"
                                v-model="selectedInvoiceRowRiferimentoData" user-format="DD/MM/YYYY"
                                storage-format="YYYY-MM-DD"></fatel-date-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <fatel-date-field hint="Data Inizio Periodo" persistent-hint
                                v-model="selectedInvoiceRow.DataInizioPeriodo" user-format="DD/MM/YYYY"
                                storage-format="YYYY-MM-DD"></fatel-date-field>
            </v-flex>
            <v-flex xs6>
              <fatel-date-field hint="Data Fine Periodo" persistent-hint v-model="selectedInvoiceRow.DataFinePeriodo"
                                user-format="DD/MM/YYYY" storage-format="YYYY-MM-DD"></fatel-date-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="saveInvoiceRowDetails">
            Salva
          </v-btn>
          <v-btn color="red darken-1" flat="flat" @click="invoiceRowNotesDialog=false">
            Annulla
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="finalizeDialog" max-width="510" :persistent="true"
              :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card>
        <v-card-title class="headline">Invio Fattura allo SDI</v-card-title>
        <v-card-text>
          Attenzione: confermando l'operazione, il sistema renderà definitiva la fattura e la invierà allo
          SDI.
          <br/>
          Si vuole procedere con l'operazione?
          <template v-if="finalizationError">
            <br/><br/>
            Errori riscontrati:
            <br/>
            <code style="width: 100%;">{{ finalizationError }}</code>
          </template>

          <template v-if="finalizationError">
            <v-checkbox v-model="force" label="Forza errori non bloccanti"></v-checkbox>
          </template>

          <v-btn v-if="finalizationError" icon small @click="downloadXmlFixed">
            <v-icon small>fa-file-code</v-icon>
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat="flat" @click="check" :loading="checking">
            Controlla
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="finalize" :loading="finalizing">
            Procedi
          </v-btn>
          <v-btn color="red darken-1" flat="flat" @click="finalizeDialog=false">
            Annulla
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

    <v-bottom-sheet v-model="vatHelpVisible" hide-overlay inset>
      <v-card tile style="max-height: 600px;" class="scroll">
        <v-card-title>
          <h4>
            <slot name="title"></slot>
          </h4>
        </v-card-title>
        <v-card-text>
          <div>
            <font size="2">
              <table width="100%" cellpadding="1" border="1">
                <thead>
                <tr>
                  <th>
                    <p align="center"><strong>Operazione</strong></p>
                  </th>
                  <th>
                    <p align="center"><strong>Descrizione</strong></p>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <p>(N1)<br/>Esclusa ex art. 15 DPR 633/1972</p>
                  </td>
                  <td>
                    Il codice va utilizzato per le <b>operazioni escluse</b> ai sensi dell’art. 15, DPR n. 633/72. In
                    particolare, va utilizzato per:
                    <br/>
                    <ul>
                      <li>
                        le somme dovute a titolo di interessi moratori / penalità per
                        ritardi / altre irregolarità nell’adempimento degli obblighi del
                        cessionario / committente
                      </li>
                      <li>
                        i beni ceduti a titolo di sconto, premio o abbuono in conformità
                        alle originarie condizioni contrattuali (tranne quelli la cui
                        cessione è soggetta ad aliquota IVA più elevata);
                      </li>
                      <li>
                        le somme dovute a titolo di rimborso delle anticipazioni fatte
                        in nome e per conto della controparte, purché regolarmente
                        documentate.
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N2.1)<br/>Non soggette ex artt. da 7 a 7-septies</p>
                  </td>
                  <td>
                      Il codice va utilizzato per le operazioni non soggette ad IVA per
                      carenza del requisito della territorialità di cui agli artt. da 7 a
                      7-septies, DPR n. 633/72, per le quali la relativa fattura va emessa
                      ai sensi dell’art. 21, comma 6-bis, DPR n. 633/72.
                      <br/>
                    Tali operazioni sono riepilogate a rigo VE34 del mod. IVA.
                    <br/>
                    Relativamente alle operazioni di cui alla lett. a) del citato comma
                    6-bis, deve essere inserita la dicitura “Inversione contabile” nel
                    campo 2.2.1.16.2 del blocco 2.2.1.16 AltriDatiGestionali.
                    <br/>
                    Trattasi delle cessioni di beni / prestazioni di servizi, diverse da
                    quelle di cui all’art. 10, comma 1, nn. da 1) a 4) e 9), DPR n. 633/72
                    effettuate nei confronti di soggetti passivi UE debitori dell’imposta.
                    <br/>
                    Per tali operazioni non risulta più utilizzabile il codice N6.
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N2.2)<br/>Non soggette altri casi</p>
                  </td>
                  <td>
                    <ul>
                      <li>fatture emesse da un contribuente forfetario</li>
                      <li>operazioni c.d. "monofase" ex art. 74, DPR n. 633/72 (ad esempio, editoria)</li>
                      <li>quota non soggetta (60%) cessione autoveicoli acquistati con IVA detratta nella misura del 40%</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N3.1)<br/>Non imponibili - Esportazioni</p>
                  </td>
                  <td>
                    Il codice va utilizzato in caso di esportazioni di beni ex art. 8,
                    comma 1, lett. a), b) e b-bis), DPR n. 633/72, tra le quali sono
                    ricomprese anche:
                    <ul>
                      <li>le cessioni, nei confronti dei cessionari / commissionari di
                        questi, eseguite mediante trasporto / spedizione di beni fuori
                        dall’UE, a cura o a nome del cedente / suoi commissionari</li>
                      <li>le cessioni di beni prelevati da un deposito IVA con trasporto
                        / spedizione fuori dall’UE ex art. 50-bis, comma 4, lett. g), DL
                        n. 331/93.</li>
                    </ul>
                    Tali operazioni sono riepilogate a rigo VE30, campo 2 del mod. IVA
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N3.2)<br/>Non imponibili cessioni intraUE</p>
                  </td>
                  <td>
                    Il codice va utilizzato in caso di cessioni intraUE ex art. 41, DL n.
                    331/93, tra le quali sono comprese:
                    <ul>
                      <li>l’ipotesi in cui il cedente nazionale consegna i beni per conto del
                        proprio acquirente UE in uno Stato membro diverso da quello
                        di appartenenza di quest’ultimo (triangolare UE promossa da
                        soggetto di altro Stato UE)</li>
                      <li>l’ipotesi di cessione di beni da parte di un soggetto nazionale
                        che fa consegnare gli stessi dal proprio fornitore UE al
                        proprio cessionario di un altro Stato membro ivi designato al
                        pagamento dell’imposta (triangolare UE promossa da soggetto
                        passivo nazionale)</li>
                      <li>le cessioni intraUE di beni prelevati da un deposito IVA con
                        spedizione in altro Stato UE ex art. 50-bis, comma 4, lett. f),
                        DL n. 331/93;</li>
                      <li>
                        le cessioni intraUE di prodotti agricoli ed ittici, anche se non
                        compresi nella Tabella A, parte I, DPR n. 633/72, effettuate da
                        produttori agricoli ex art. 34, DPR n. 633/72
                      </li>
                      <li>le cessioni di beni ex art. 58, comma 1, DL n. 331/93, ossia,
                        nei confronti di soggetti passivi nazionali o di commissionari
                        di questi, eseguite mediante trasporto o spedizione dei beni in
                        altro Stato UE a cura o a nome del cedente nazionale.</li>
                    </ul>
                    Tali operazioni sono riepilogate a rigo VE30, campo 3 del mod. IVA
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N3.5)<br/>Non imponibili dichiarazione d’intento</p>
                  </td>
                  <td>
                    Il codice va utilizzato in caso di operazioni non imponibili
                    effettuate nei confronti di esportatori abituali che hanno rilasciato
                    la dichiarazione d’intento
                    <br/>
                    Tali operazioni sono riepilogate a rigo VE31 del mod. IVA.
                    <br/>
                    Il codice va utilizzato anche dal cessionario esportatore abituale
                    che utilizza il plafond, ad esempio, nei seguenti casi:
                    <ul>
                      <li>tipo documento TD18, integrazione per acquisto intraUE di beni</li>
                      <li>tipo documento TD23, estrazione beni da un deposito IVA
                        introdotti ex art. 50, comma 4, lett. c), DL n. 331/93.</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N4)<br/>Esenti</p>
                  </td>
                  <td>
                    Il codice va utilizzato per evidenziare le operazioni esenti ex art.
                    10, DPR n. 633/72. Come precisato dall’Agenzia nella Risoluzione
                    5.7.2017, n. 87/E, in caso di acquisto intraUE effettuato ai sensi
                    dell’art. 42, DL n. 331/93, che non viene integrato con l’IVA, in
                    caso di operazione esente va riportato il codice N4.
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N5)<br/>Regime del margine</p>
                  </td>
                  <td>
                    <p>1) cessioni o acquisti (ad es. da un concessionario di auto) di&nbsp;<strong>beni usati</strong>,
                      di&nbsp;<strong>oggetti d'arte</strong>, di&nbsp;<strong>antiquariato
                        o</strong>&nbsp;da&nbsp;<strong>collezione</strong>, con lo specifico regime speciale (artt. 36
                      e
                      s. DL 41/95)&nbsp;<strong>(2)</strong>;<br/>2) cessioni o acquisti con IVA inclusa, ma non esposta
                      in fattura, da parte delle&nbsp;<strong>agenzie di viaggi e turismo</strong>, con il regime
                      speciale&nbsp;
                      (art. 74 ter DPR 633/1972)</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N6.1)<br/>Inversione contabile
                      cessione di rottami
                      e altri materiali di
                      recupero</p>
                  </td>
                  <td>
                    Il codice va utilizzato in caso di cessioni in Italia di rottami ed altri
                    materiali di recupero di cui all’art. 74, commi 7 e 8, DPR n. 633/72.<br/>
                    Tali operazioni sono riepilogate a rigo VE35, campo 2 del mod. IVA.
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N6.3)<br/>Inversione contabile
                      subappalto nel
                      settore edile</p>
                  </td>
                  <td>
                    Il codice va utilizzato in caso di prestazioni di servizi rese nel
                    settore edile da subappaltatori senza addebito dell’imposta ai
                    sensi dell’art. 17, comma 6, lett. a), DPR n. 633/72.<br/>
                    Tali operazioni sono riepilogate a rigo VE35, campo 4 del mod. IVA.
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N6.4)<br/>Inversione contabile
                      cessione di fabbricati</p>
                  </td>
                  <td>
                    Il codice va utilizzato in caso di cessioni di fabbricati / porzioni di
                    fabbricato per le quali l’imposta è dovuta dal cessionario, ai sensi
                    dell’art. 17, comma 6, lett. a-bis), DPR n. 633/72.<br/>
                    Tali operazioni sono riepilogate a rigo VE35, campo 5 del mod. IVA.
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N6.7)<br/>Inversione contabile
                      prestazioni comparto
                      edile e settori connessi</p>
                  </td>
                  <td>
                    Il codice va utilizzato in caso di prestazioni di servizi di pulizia /
                    demolizione / installazione di impianti e di completamento relative
                    a edifici per le quali l’imposta è dovuta dal cessionario, ai sensi
                    dell’art 17, comma 6, lett. a-ter), DPR n. 633/72.<br/>
                    Tali operazioni sono riepilogate a rigo VE35, campo 8 del mod. IVA.
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N6.8)<br/>Inversione contabile
                      operazioni settore
                      energetico</p>
                  </td>
                  <td>
                    Il codice va utilizzato in caso di operazioni del settore energetico
                    per le quali l’imposta è dovuta dal cessionario, ai sensi dell’art. 17,
                    comma 6, lett. d-bis), d-ter) e d-quater), DPR n. 633/72.<br/>
                    Tali operazioni sono riepilogate a rigo VE35, campo 9 del mod. IVA.
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>(N7)<br/>IVA assolta in altro stato UE</p>
                  </td>
                  <td>
                    <p>1)&nbsp;<strong>vendite a distanza</strong>&nbsp;a privati UE, in base a cataloghi, per
                      corrispondenza e simili (artt. 40 c. 3 e 4 e 41 c. 1 lettera b) DL 331/1993), se l&rsquo;ammontare
                      delle cessioni effettuate in altro Stato comunitario abbia superato nell&rsquo;anno precedente o
                      superi in quello in corso &euro; 100.000 ovvero la diversa soglia stabilita dallo stesso
                      Stato;<br/>2)
                      prestazioni di servizi rese tramite mezzi elettronici o di telecomunicazione e di
                      teleradiodiffusione (art. 7 sexies lettere f) e g) DPR 633/72, art. 74 sexies DPR 633/72), se il
                      soggetto IVA italiano ha&nbsp;<strong>aderito al MOSS</strong>&nbsp;(regime del Mini One Stop
                      Shop),
                      in Italia come negli altri Stati comunitari&nbsp;<strong>(4)</strong></p>
                  </td>
                </tr>
                </tbody>
              </table>
            </font>
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </v-container>
</template>

<script>

import _get from 'lodash/get';
import _set from 'lodash/set';
import _find from 'lodash/find';
import InvoiceApi from '@/api/invoices';
import SubjectsApi from '@/api/subjects';
import ProductsApi from '@/api/products';
import DomainDataApi from '@/api/domaindata';
import InvoicesApi from "@/api/invoices";

export default {
  name: 'InvoiceWizard',
  data() {
    return {
      formattedInvoiceDate: '',
      invoice: {},
      invoiceFatel: {},
      e1: 0,
      valid: true,
      currencies: [
        'EUR',
        'USD',
      ],
      sections: [
        '',
        'A',
        'B',
        'C',
        'R',
        'PA'
      ],
      documentTypes: [
        {'value': 'TD01', 'text': 'Fattura'},
        {'value': 'TD24', 'text': 'Fattura Differita'},
        {'value': 'TD02', 'text': 'Acconto / anticipo su fattura'},
        {'value': 'TD03', 'text': 'Acconto / anticipo su parcella'},
        {'value': 'TD04', 'text': 'Nota di credito'},
        {'value': 'TD05', 'text': 'Nota di debito'},
        {'value': 'TD06', 'text': 'Parcella'},

        {'value': 'TD26', 'text': 'Cessione Beni Ammortizzabili'},
      ],
      elencoTrattenutaRivalsa: [
        {text: 'Trattenuta', value: 'Trattenuta'},
        {text: 'Rivalsa', value: 'Rivalsa'},
      ],
      previewDialog: false,
      isSubjectLoading: false,
      subjects: [],
      subjectSearch: '',
      productsHeaders: [
        {text: 'Cod. Art.', align: 'left', value: 'CodiceArticolo[0].CodiceValore', width: '5%', sortable: false},
        {text: 'Descrizione', align: 'left', value: 'Descrizione', width: '30%', sortable: false},
        {text: 'Numero', align: 'right', value: 'Quantita', width: '2%', sortable: false},
        {text: 'Unità', align: 'left', value: 'UnitaMisura', width: '2%', sortable: false},
        {text: 'Aliquota IVA', align: 'left', value: 'AliquotaIva', width: '28%', sortable: false},
        {text: 'Prezzo Unitario', align: 'right', value: 'PrezzoUnitario', width: '2%', sortable: false},
        {text: 'Sconto/Maggior.', align: 'right', value: 'Sconto', width: '3%', sortable: false},
        {text: 'Prezzo Totale', align: 'right', value: 'PrezzoTotale', width: '2%', sortable: false},
        {text: '', align: 'center', value: 'Id', width: '2%', sortable: false}
      ],
      selectedProduct: {},
      products: [],
      productSearch: '',
      isProductLoading: false,
      vatTypes: [],
      datiPagamento: [],
      finalizeDialog: false,
      invoiceProductsCalculating: false,
      selectedInvoiceRow: {},
      selectedInvoiceRowIndex: 0,
      invoiceRowNotesDialog: false,
      finalizing: false,
      checking: false,
      finalizationError: '',
      force: false,
      vatHelpVisible: false,
    }
  },
  created: function () {
    this.page = this.$route.params.page;
    let invoiceId = parseInt(this.$route.params.id);
    this.$store.dispatch('setInvoiceId', invoiceId);

    DomainDataApi.getVatList()
        .then(t => {
          this.vatTypes = t.data;
        });

    let subjectPromise = SubjectsApi.getSubjects()
        .then(res => {
          this.subjects = res.data;
        })
        .catch(err => {
          console.log(err)
        });

    InvoiceApi.getInvoice(this.$store.state.invoiceId)
        .then(t => {
          this.formattedInvoiceDate = this.$root.formatDate(t.data.Date);
          this.invoice = t.data;
          this.invoiceFatel = JSON.parse(this.invoice.Content);

          this.datiPagamento = _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiPagamento');

          if (this.$route.query.setSubject) {
            subjectPromise.then(() => {
              this.selectedSubject = _find(this.subjects, {'Id': parseInt(this.$route.query.setSubject)}) || {};
            })
          }
        })
        .catch(t => {
          this.alertText = t.response.data;
          this.alertType = 'error';
          this.alert = true;
        });
  },
  mounted: function () {
    this.$refs.pond.server = {
      process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
        console.log(fieldName, file, metadata, load, error, progress, abort, transfer, options)
        progress(true, 1, file.size)
        let reader = new FileReader()
        reader.onload = (e) => {
          let bytes = Array.from(new Uint8Array(e.target.result))
          // if you want the base64encoded file you would use the below line:
          let base64StringFile = btoa(bytes.map((item) => String.fromCharCode(item)).join(''))

          let attList = this.attachments
          if (!attList || attList.length == 0) {
            attList = []
          }
          let att = {
            'NomeAttachment': file.name,
            'FormatoAttachment': 'PDF',
            'DescrizioneAttachment': file.name,
            'Attachment': base64StringFile,
          }
          attList.push(att)
          this.attachments = attList

          this.save(true).then(() => {
            progress(true, file.size, file.size)
            load(file.name);
          })
        }
        reader.readAsArrayBuffer(file)

        // Should expose an abort method so the request can be cancelled
        return {
          abort: () => {
            // This function is entered if the user has tapped the cancel button

            // Let FilePond know the request has been cancelled
            abort();
          }
        };
      }
    }
  },
  computed: {
    attachments: {
      get: function () {
        return _get(this.invoiceFatel, 'FatturaElettronicaBody[0].Allegati')
      },
      set: function (newValue) {
        _set(this.invoiceFatel, 'FatturaElettronicaBody[0].Allegati', newValue)
      }
    },
    invoiceFatelBody() {
      return _get(this.invoiceFatel, 'FatturaElettronicaBody[0]');
    },
    invoiceFatelBodyDatiGenerali() {
      return _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali');
    },
    page: {
      get: function () {
        switch (this.e1) {
          default:
          case 0:
            return 'header';
          case 1:
            return 'subject';
          case 2:
            return 'linked-documents';
          case 3:
            return 'body';
          case 4:
            return 'fiscal';
          case 5:
            return 'payment';
          case 6:
            return 'documents';
          case 7:
            return 'attachments';
          case 8:
            return 'final';
        }
      },
      set: function (newValue) {
        switch (newValue) {
          default:
          case 'header':
            this.e1 = 0;
            break;
          case 'subject':
            this.e1 = 1;
            break;
          case 'linked-documents':
            this.e1 = 2;
            break;
          case 'body':
            this.e1 = 3;
            break;
          case 'fiscal':
            this.e1 = 4;
            break;
          case 'payment':
            this.e1 = 5;
            break;
          case 'documents':
            this.e1 = 6;
            break;
          case 'attachments':
            this.e1 = 7;
            break;
          case 'final':
            this.e1 = 8;
            break;
        }
      }
    },
    selectedCurrency: {
      get: function () {
        return _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.Divisa', 'EUR');
      },
      set: function (newValue) {
        _set(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.Divisa', newValue);
      }
    },
    selectedDocumentType: {
      get: function () {
        let td = _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.TipoDocumento', this.documentTypes[0].value);
        return _find(this.documentTypes, {value: td}) || this.documentTypes[0];
      },
      set: function (newValue) {
        _set(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.TipoDocumento', newValue.value);
      }
    },
    causale: {
      get: function () {
        let causali = _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.Causale') || [''];
        return causali.join('\n');
      },
      set: function (newValue) {
        let causali = newValue.split('\n');
        _set(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.Causale', causali);
      }
    },
    invoiceNumber: {
      get: function () {
        return _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.Numero', '');
      },
      set: function (newValue) {
        this.invoice.Number = parseInt(newValue)
        _set(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.Numero', newValue)
      }
    },
    invoiceTotalAmountToPay() {
      let tot = 0;
      if (this.esigibilitaIVA == 'S') {
        let sums = _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiBeniServizi.DatiRiepilogo') || [];
        for (let i = 0; i < sums.length; i++) {
          tot += sums[i].ImponibileImporto;
        }
      } else {
        tot = _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento') || 0;
      }
      return tot
    },
    importoRitenuta() {
      return _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.ImportoRitenuta') || 0;
    },
    selectedSubject: {
      get: function () {
        return _find(this.subjects, {Id: this.invoice.SubjectId}) || {};
      },
      set: function (newValue) {
        this.invoice.SubjectId = newValue.Id;
        this.invoice.SendCourtesyCopy = newValue.InvoiceEmailSend;
        this.invoice.CourtesyEmail = newValue.InvoiceEmail;
        if (newValue.VatId != '') {
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese', newValue.Country);
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdCodice', newValue.VatId);
        } else {
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese', null);
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdCodice', null);
        }
        if (newValue.FiscalCode != '') {
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale', newValue.FiscalCode);
        } else {
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale', null);
        }
        if (newValue.IsCompany) {
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Denominazione', newValue.CompanyName);
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Nome', null);
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Cognome', null);
        } else {
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Denominazione', null);
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Nome', newValue.FirstName);
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Cognome', newValue.LastName);
        }
        if (newValue.SDICode != '') {
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario', newValue.SDICode);
        } else {
          _set(this.invoiceFatel, 'FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario', '0000000');
        }
        _set(this.invoiceFatel, 'FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario', newValue.CertifiedEmail);
        _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.Sede.Nazione', newValue.OfficeCountry);
        _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.Sede.Provincia', newValue.OfficeProvince);
        _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.Sede.Comune', newValue.OfficeCity);
        _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.Sede.CAP', newValue.OfficePostalCode);
        _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.Sede.Indirizzo', newValue.OfficeAddress);
        _set(this.invoiceFatel, 'FatturaElettronicaHeader.CessionarioCommittente.Sede.NumeroCivico', newValue.OfficeStreetNumber);
      }
    },
    invoiceProducts: {
      get: function () {
        return _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee') || [];
      },
      set: function (newValue) {
        for (let i = 0; i < newValue.length; i++) {
          newValue[i].NumeroLinea = i + 1;
        }
        this.invoiceFatel.FatturaElettronicaBody[0].DatiBeniServizi.DettaglioLinee = newValue;
      },
    },
    virtualStampType: {
      get: function () {
        return _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiBollo.BolloVirtuale', '');
      },
      set: function (newValue) {
        if (newValue == '') {
          _set(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiBollo', null);
        } else {
          _set(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiBollo.BolloVirtuale', newValue);
        }
      }
    },
    virtualStampAmount: {
      get: function () {
        return _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiBollo.ImportoBollo', '');
      },
      set: function (newValue) {
        if (newValue == '') {
          newValue = 0;
        }

        var value = parseFloat(newValue);
        if (isNaN(value)) {
          this.$root.showBottomError('Importo bollo non valido', true);
        } else {
          _set(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiBollo.ImportoBollo', value);
        }
      }
    },
    datiRitenuta: {
      get: function () {
        return _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta');
      },
      set: function (newValue) {
        _set(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiRitenuta', newValue);
      }
    },
    datiCassa: {
      get: function () {
        return _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[0]');
      },
      set: function (newValue) {
        if (newValue) {
          _set(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[0]', newValue);
        } else {
          _set(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale', null);
        }
      }
    },
    scontoMaggiorazione: {
      get: function () {
        return _get(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione[0]');
      },
      set: function (newValue) {
        if (newValue) {
          _set(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione[0]', newValue);
        } else {
          _set(this.invoiceFatel, 'FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione', null);
        }
      }
    },
    esigibilitaIVA: {
      get: function () {
        return this.invoice.VatCollectability || 'I';
      },
      set: function (newValue) {
        if (newValue) {
          this.invoice.VatCollectability = newValue;
        } else {
          this.invoice.VatCollectability = 'I';
        }
      }
    },
    selectedInvoiceRowTipoDato: {
      get: function () {
        return _get(this.selectedInvoiceRow, 'AltriDatiGestionali[0].TipoDato')
      },
      set: function (newValue) {
        _set(this.selectedInvoiceRow, 'AltriDatiGestionali[0].TipoDato', newValue)
      }
    },
    selectedInvoiceRowRiferimentoTesto: {
      get: function () {
        return _get(this.selectedInvoiceRow, 'AltriDatiGestionali[0].RiferimentoTesto')
      },
      set: function (newValue) {
        _set(this.selectedInvoiceRow, 'AltriDatiGestionali[0].RiferimentoTesto', newValue)
      }
    },
    selectedInvoiceRowRiferimentoNumero: {
      get: function () {
        let num = _get(this.selectedInvoiceRow, 'AltriDatiGestionali[0].RiferimentoNumero')
        if (num) {
          return parseFloat(num)
        } else {
          return null
        }
      },
      set: function (newValue) {
        let num = parseFloat(newValue)
        if (num) {
          _set(this.selectedInvoiceRow, 'AltriDatiGestionali[0].RiferimentoNumero', num)
        } else {
          _set(this.selectedInvoiceRow, 'AltriDatiGestionali[0].RiferimentoNumero', null)
        }
      }
    },
    selectedInvoiceRowRiferimentoData: {
      get: function () {
        let dt = _get(this.selectedInvoiceRow, 'AltriDatiGestionali[0].RiferimentoData')
        return dt
      },
      set: function (newValue) {
        _set(this.selectedInvoiceRow, 'AltriDatiGestionali[0].RiferimentoData', newValue)
      }
    }
  },
  watch: {
    '$route'(to, from) {
      // react to route changes...
      this.page = to.params.page;
    },
    subjectSearch() {
      if (!this.subjects) return;
      // Items have already been loaded
      if (this.subjects.length > 0) return;
      // Items have already been requested
      if (this.isSubjectLoading) return;
      this.isSubjectLoading = true;
      // Lazily load input items
      SubjectsApi.getSubjects()
          .then(res => {
            this.subjects = res.data;
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isSubjectLoading = false))
    },
    productSearch() {
      if (!this.products) return;
      // Items have already been loaded
      if (this.products.length > 0) return;
      // Items have already been requested
      if (this.isProductLoading) return;
      this.isProductLoading = true;
      // Lazily load input items
      ProductsApi.getProducts()
          .then(res => {
            res.data.unshift({
              ArticleCode: '',
              Description: '<RIGA VUOTA>',
              Id: 0,
              TypeCode: '',
              UnitOfMeasure: '',
              UnitPrice: 0,
              VatPercentage: 0,
              VatTypeId: 0,
            });
            this.products = res.data;
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isProductLoading = false))
    },
    invoiceProducts: {
      handler: function (newValue) {
        for (let i = 0; i < newValue.length; i++) {
          let qta = newValue[i].Quantita || 1;
          let tot = parseFloat((newValue[i].PrezzoUnitario * qta).toFixed(5)) || 0;
          let scontoMaggiorazione = 0;
          if (newValue[i].ScontoMaggiorazione) {
            if (newValue[i].ScontoMaggiorazione[0].Importo && newValue[i].ScontoMaggiorazione[0].Importo > 0) {
              scontoMaggiorazione = newValue[i].ScontoMaggiorazione[0].Importo;
            }
            if (newValue[i].ScontoMaggiorazione[0].Percentuale && newValue[i].ScontoMaggiorazione[0].Percentuale > 0) {
              scontoMaggiorazione = tot * newValue[i].ScontoMaggiorazione[0].Percentuale / 100;
            }
            if (newValue[i].ScontoMaggiorazione[0].Tipo === 'SC') {
              scontoMaggiorazione = -scontoMaggiorazione;
            }
          }
          newValue[i].PrezzoTotale = parseFloat((tot + scontoMaggiorazione).toFixed(5));
        }
      },
      deep: true,
    },
  },
  methods: {
    downloadAttachment: function (index, name) {
      InvoiceApi.getAttachment(this.$store.state.invoiceId, index)
          .then(t => {
            let blob = new Blob([t.data], {type: 'application/pdf'});
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = name;
            link.click();
          });
    },
    removeAttachment: function (item) {
      let att = this.attachments || []
      let pos = att.indexOf(item)
      if (pos >= 0) {
        att.splice(pos, 1)
      }
      this.attachments = att
      this.save(true)
    },
    save(silent) {
      this.invoice.Date = this.$root.parseDateISO(this.formattedInvoiceDate);
      this.invoiceFatel.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.Data = this.$root.parseDate(this.formattedInvoiceDate);

      this.invoice.Content = JSON.stringify(this.invoiceFatel);

      return InvoiceApi.saveInvoice(this.$store.state.invoiceId, this.invoice)
          .then(t => {
            if (!silent) {
              this.$root.showBottomMessage('Fattura salvata correttamente', false);
            }
            this.invoice = t.data;
            this.invoiceFatel = JSON.parse(this.invoice.Content);
          })
          .catch(t => {
            if (t.response) {
              let msg = t.response.data;
              if (msg) {
                this.$root.showBottomError(msg, true);
              } else {
                this.$root.showBottomError('Errore nel salvataggio, verifica i dati o contatta l\'assistenza', true);
              }
            } else {
              this.$root.showBottomError('Errore nel salvataggio, verifica i dati o contatta l\'assistenza', true);
            }
          });
    },
    goToNextPage() {
      this.e1++;
      this.goToPage(this.page);
    },
    goToPreviousPage() {
      this.e1--;
      this.goToPage(this.page);
    },
    goToPage(newPage) {
      this.save(true).then(() => {
        //this.page = newPage;
        this.$router.push({
          name: 'invoiceWizard',
          params: {id: this.$store.state.invoiceId, page: newPage}
        });
      });
    },
    preview() {
      this.save(true).then(() => {
        this.previewDialog = true;
      });
    },
    newSubject() {
      SubjectsApi.newSubject()
          .then(t => {
            this.$router.push({
              name: 'subjectFromInvoice',
              params: {id: t.data.Id, invoiceId: this.$store.state.invoiceId}
            });
          })
          .catch(t => {
            this.$root.showBottomError('Errore, contattare l\'assistenza', true);
          });
    },
    editSubject() {
      this.$router.push({
        name: 'subjectFromInvoice',
        params: {id: this.selectedSubject.Id, invoiceId: this.$store.state.invoiceId}
      });
    },
    newProduct() {
      ProductsApi.newProduct()
          .then(t => {
            this.$router.push({
              name: 'productFromInvoice',
              params: {id: t.data.Id, invoiceId: this.$store.state.invoiceId}
            });
          })
          .catch(() => {
            this.$root.showBottomError('Errore, contattare l\'assistenza', true);
          });
    },
    assignProduct() {
      var p = this.invoiceProducts || [];

      let vat = _find(this.vatTypes, {Id: this.selectedProduct.VatTypeId});
      let vatPerc = (vat) ? vat.Percentage : null;
      let vatNature = (vat) ? vat.SdiCode : null;

      p.push({
        CodiceArticolo: [{
          CodiceTipo: this.selectedProduct.TypeCode,
          CodiceValore: this.selectedProduct.ArticleCode,
        }],
        Descrizione: this.selectedProduct.Description,
        PrezzoUnitario: parseFloat(this.selectedProduct.UnitPrice) || 0,
        Quantita: 1,
        AliquotaIVA: vatPerc,
        Natura: vatNature,
        UnitaMisura: this.selectedProduct.UnitOfMeasure,
        PrezzoTotale: parseFloat(this.selectedProduct.UnitPrice) || 0,
      });
      this.invoiceProducts = p;

      console.log('saving');
      this.save(true);
    },
    deleteProduct(product) {
      if (window.confirm('Eliminare la riga?')) {
        this.invoiceProducts.splice(this.invoiceProducts.indexOf(product), 1);
      }
    },
    setDatiPagamento(newValue) {
      if (this.invoiceFatel.FatturaElettronicaBody) {
        this.invoiceFatel.FatturaElettronicaBody[0].DatiPagamento = newValue;
      }
    },
    updateDatiRitenuta(newValue) {
      this.datiRitenuta = newValue;
    },
    updateDatiCassa(newValue) {
      this.datiCassa = newValue;
    },
    updateScontoMaggiorazione(newValue) {
      this.scontoMaggiorazione = newValue;
    },
    updateDatiOrdineAcquisto(newValue) {
      if (this.invoiceFatel.FatturaElettronicaBody) {
        this.invoiceFatel.FatturaElettronicaBody[0].DatiGenerali.DatiOrdineAcquisto = newValue;
      }
    },
    updateDatiContratto(newValue) {
      if (this.invoiceFatel.FatturaElettronicaBody) {
        this.invoiceFatel.FatturaElettronicaBody[0].DatiGenerali.DatiContratto = newValue;
      }
    },
    async check() {
      this.checking = true;
      this.finalizationError = '';
      try {
        await this.save(true);
        let checkId = await InvoiceApi.checkInvoice(this.$store.state.invoiceId, this.invoice, this.force);
        await new Promise(resolve => setTimeout(resolve, 2000)); // 2 sec
        let checkResp = await InvoiceApi.checkInvoiceResult(this.$store.state.invoiceId, checkId.data);
        let retries = 15;
        while (retries > 0 && !checkResp.data.completato) {
          await new Promise(resolve => setTimeout(resolve, 2000)); // 3 sec
          checkResp = await InvoiceApi.checkInvoiceResult(this.$store.state.invoiceId, checkId.data);
          retries--;
        }
        if (checkResp.data.completato === true) {
          if (checkResp.data.fatture[0].esito === true) {
            this.$root.showBottomMessage('Fattura controllata con successo', true);
          } else {
            let msg = ``
            for (const value of Object.values(checkResp.data.fatture[0].errori)) {
              msg += value.descrizione + "\n";
            }
            this.finalizationError = msg;
          }
        } else {
          this.finalizationError = `Collegamento con il controllo ministeriale assente. E' possibile procedere comunque all'invio con l'opzione "Forza errori non bloccanti"'`;
        }
      }
      catch (e) {
        if (e.response) {
          let msg = e.response.data;
          if (msg) {
            this.finalizationError = msg;
          } else {
            this.$root.showBottomError('Errore nel controllo, contatta l\'assistenza', true);
          }
        } else {
          this.$root.showBottomError('Errore nel controllo, contatta l\'assistenza', true);
        }
      }
      finally {
        this.checking = false;
      }
    },
    finalize() {
      this.finalizing = true;
      this.finalizationError = '';
      return this.save(true).then(() => {
        return InvoiceApi.finalizeInvoice(this.$store.state.invoiceId, this.invoice, this.force)
            .then(() => {
              this.$root.showBottomMessage('Fattura inviata correttamente allo SDI', true);
              setTimeout(function (that) {
                that.$router.push({name: 'sent'});
              }(this), 2000);
            })
            .catch((t) => {
              if (t.response) {
                let msg = t.response.data;
                if (msg) {
                  this.finalizationError = msg;
                  //this.$root.showBottomError(msg, true);
                } else {
                  this.$root.showBottomError('Errore nel salvataggio, verifica i dati o contatta l\'assistenza', true);
                }
              } else {
                this.$root.showBottomError('Errore nel salvataggio, verifica i dati o contatta l\'assistenza', true);
              }
            })
            .finally(() => {
              this.finalizing = false;
            });
      });
    },
    saveInvoiceRowDetails() {
      this.invoiceRowNotesDialog = false;
    },
    showDetails(item, index) {
      this.selectedInvoiceRow = item;
      this.selectedInvoiceRowIndex = index;
      this.invoiceRowNotesDialog = true;
    },
    productsFilter(item, queryText, itemText) {
      const desc = item.Description.toLowerCase();
      const typeCode = item.TypeCode.toLowerCase();
      const articleCode = item.ArticleCode.toLowerCase();

      const searchText = queryText.toLowerCase();

      let found = false;

      if (!found && typeCode) {
        found = typeCode.indexOf(searchText) > -1;
      }
      if (!found && articleCode) {
        found = articleCode.indexOf(searchText) > -1;
      }
      if (!found && desc) {
        found = desc.indexOf(searchText) > -1;
      }

      return found;
    },
    downloadXmlFixed() {
      InvoiceApi.getXMLFixed(this.$store.state.invoiceId)
          .then(t => {
            let blob = new Blob([t.data], { type: 'application/xml' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'bozza_'+this.$store.state.invoiceId+'.xml';
            link.click();
          });
    }
  },
}
</script>
